import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { superAdminBillsApi } from "../../../api/superAdminBillsApi";
import { CircularIndeterminate } from "../../../components/common/CircularIndeterminate";
import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";
import ServerSideSearchBar from "../../../components/common/table/ServerSideSearchBar";
import { useServerSidePagination } from "../../../hooks/PaginationHooks";
import { useProcessingRequest } from "../../../store/selectors/tableManagementSelector";
import InvoicesTableHeader from "./InvoicesTableHeader";
import InvoicesTableRow from "./InvoicesTableRow";
import { SidebarLinkPathTypes } from "../../../scaffold/ui/LinkTypes";
import { SearchBarWrapper } from "../../../components/common/stylings/SearchBarWrapper.styles";


export default function InvoicesAdminPage() {
    const { t } = useTranslation();

    const breadcrumbs = [
        {
            title: "superAdminPage.title",
            link: "superadminarea",
        },
        {
            title: "invoicesPage.title",
            link: SidebarLinkPathTypes.superAdminInvoices,
        },
    ];

    const processingRequest = useProcessingRequest()
    const paginatedData = useServerSidePagination(
        async (paginationParameters) => {
            const res = await superAdminBillsApi.getSuperAdminInvoices(paginationParameters);
            return res?.getResultOrNull();
        },
        [],
        "desc",
        "invoiceNumber"
    )

    return (<>
        <PageTitle breadcrumbs={breadcrumbs} title={t("invoicesPage.title")} />

        <MainContentWrapper>
            <SearchBarWrapper>
                <ServerSideSearchBar onSearchHandler={paginatedData.handleOnSearch} />
            </SearchBarWrapper>

            <TableWrapper
                minWidth="1000px"
                columnsTemplate="1.4fr 1fr 1fr 0.5fr"
            >
                <InvoicesTableHeader
                    paginatedData={paginatedData}
                    showCompanyName />

                <Box sx={{ display: "contents" }}>
                    {paginatedData.items.map((item) =>
                        <InvoicesTableRow
                            row={item}
                            showCompanyName
                        />)
                    }
                </Box>
            </TableWrapper>
            <ServerSidePagination paginatedData={paginatedData} />
        </MainContentWrapper>

        <CircularIndeterminate processingRequest={processingRequest} />
    </>);
}